import styled from "styled-components";
import { StyledLoyaltyContainer } from "@/components/account/styles";
import { LAYOUT } from "@/constants/styles";
import { getFontStyles } from "@/redux/cmsConfig/utils";

export const StyledInboxContainer = styled(StyledLoyaltyContainer)`
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    overflow-y: scroll;
    padding: ${LAYOUT.GUTTER}px;
  }
`;

export const StyledMessagesContainer = styled.div`
  height: calc(
    100vh - ${LAYOUT.HEADERHEIGHT}px - ${LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP}px -
      ${LAYOUT.GUTTER}px
  );
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 767px) {
    height: auto;
    min-height: calc(
      100vh - ${LAYOUT.MOBILE_HEADERHEIGHT}px -
        ${LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE}px
    );
    padding-bottom: ${LAYOUT.GUTTER}px;
  }
`;

export const StyledEmptyMessagesContainer = styled.div(({ theme }) => ({
  alignItems: "center",
  border: `1px solid ${theme.auth_page.border_color ?? "transparent"}`,
  borderRadius: `${theme.auth_page.border_radius ?? 0}px`,
  display: "flex",
  height: "100%",
  margin: "20px",
  justifyContent: "center",
  padding: "20px",
  textAlign: "center",
  ...getFontStyles(theme.auth_page.font),

  "@media (max-width: 767px)": {
    margin: "10px",
  },
}));
